/**
 * Class description
 *
 * Created: 2018-06-13
 * @author jonas
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {
    INearWinReelDividerConfig,
    NearWinReelDivider
} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";

export class DirtyWildsNearWinReelDivider extends NearWinReelDivider {
    private _nearWinSpines:PIXI.spine.Spine[] = [];
    private _activeDirtyWildReelId:number;
    private _dirtyWildReelIndexMap:number[][];

    constructor(config:INearWinReelDividerConfig) {
        super(config);
        this._dirtyWildReelIndexMap = config.reelIndexMap;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onDirtyWildSpinStart());
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onDirtyWildPlayReelNearWinAttention(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_ANIMATION_COMPLETE, (event:GameEvent) => this.onDirtyWildReelSpinAnimationComplete(event.params[0]));
    }

    protected initAnimations():void {
        // super.initAnimations();
        this._nearWinDividers = [];
        for(let i:number = 0; i < this._positions.length; i++) {
            const divider:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.REEL_ATTENTION));
            // const animation:PIXI.spine.core.Animation = divider.spineData.findAnimation("LavaAttention");
            // divider.state.setAnimationWith(0, animation, true);
            this._nearWinSpines.push(divider);
            if(divider) {
                divider.x = this._positions[i][0];
                divider.y = this._positions[i][1];
                divider.alpha = 0;
                this._nearWinContainer.addChild(divider);
            }
        }
    }


    protected createNearWinDivider(index:number):TimelineSprite | null {
        const sprite:TimelineSprite | null = super.createNearWinDivider(index);
        if(sprite) {
            sprite.blendMode = PIXI.BLEND_MODES.ADD;
        }
        return sprite;
    }

    // To override for different animations.
    protected getDirtyWildDividerAnimation(divider:PIXI.spine.Spine):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.call(() => {divider.alpha = 1});
        timeline.add(new SpineTween(divider, 0, "LavaAttention", -1));
        return timeline;
    }

    // To override for different animations.
    protected getDirtyWildDividerEndAnimation(divider:PIXI.spine.Spine):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(new TweenLite(divider, 0.2, {alpha : 0}));
        timeline.add(new SpineTween(divider, 0, null,));
        return timeline;
    }

    private onDirtyWildSpinStart():void {
        this._activeDirtyWildReelId = -1;
    }

    private onDirtyWildPlayReelNearWinAttention(reelId:number):void {
        this._activeDirtyWildReelId = reelId;

        const activeDividerIndexes:number[] = this._dirtyWildReelIndexMap[this._activeDirtyWildReelId];
        if(activeDividerIndexes !== null && activeDividerIndexes.length > 0) {
            for(let i:number = 0; i < activeDividerIndexes.length; i++) {
                const activeIndex = activeDividerIndexes[i];
                if(this._nearWinSpines[activeIndex]) {
                    const tl:TimelineLite = new TimelineLite();
                    tl.add(this.getDirtyWildDividerAnimation(this._nearWinSpines[activeIndex - 1]!), 0);
                }
            }
            this.playNearWinSound(reelId);
        }
    }

    private onDirtyWildReelSpinAnimationComplete(stopData:IReelStoppedData):void {
        if(stopData.reelId != this._activeDirtyWildReelId) {
            return;
        }
        const activeDividerIndexes:number[] = this._dirtyWildReelIndexMap[this._activeDirtyWildReelId];
        for(let i:number = 0; i < activeDividerIndexes.length; i++) {
            const activeIndex = activeDividerIndexes[i];
            if(this._nearWinSpines[activeIndex]) {
                const tl:TimelineLite = new TimelineLite();
                tl.add(this.getDirtyWildDividerEndAnimation(this._nearWinSpines[activeIndex - 1]!), 0);
            }
        }
        if(stopData.quickStop) {
            SlotGame.sound.stopEffect(this.getNearWinSoundName(stopData.reelId));
        }
    }

    private getNearWinSoundName(reelId:number):string {
        switch(reelId) {
            case 2:
                return DirtyWildsSoundConfig.ANTICIPATION_2;
            case 3:
                return DirtyWildsSoundConfig.ANTICIPATION_3;
            default:
                return DirtyWildsSoundConfig.ANTICIPATION_1;
        }
    }

    protected playNearWinSound(reelId:number):void {
        if(DirtyWildGameModuleConfig.reelAreaController.getFirstNearWinReel(reelId) > -1) {
            SlotGame.sound.playEffect(this.getNearWinSoundName(reelId));
        }
    }

}